const url = "https://bus.crediya.fin.ec";
//const url = "https://54d3-186-3-60-87.sa.ngrok.io";
//onst url = "http://localhost:3000";
export default url;
